import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-155">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-156">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-157" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="relative bg-stone-900 border border-stone-800 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" data-id="element-158">
            <div className="flex items-center justify-between p-6 border-b border-stone-800" data-id="element-159">
              <h2 className="text-xl font-bold text-white" data-id="element-160">{title}</h2>
              <button onClick={onClose} className="w-8 h-8 rounded-full bg-stone-800 hover:bg-stone-700 flex items-center justify-center transition-colors" data-id="element-161">
                <X className="w-4 h-4 text-stone-400" data-id="element-162" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-stone-300 text-sm leading-relaxed space-y-4" data-id="element-163">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-stone-950 py-12 border-t border-stone-900 text-center px-4" data-id="element-164">
        <p className="text-stone-500 text-sm" data-id="element-165">
          © {new Date().getFullYear()} Protocolo P.A.U. Todos los derechos
          reservados.
        </p>
        <p className="text-stone-600 text-xs mt-2 max-w-2xl mx-auto" data-id="element-166">
          Este producto no sustituye el consejo médico profesional, diagnóstico
          o tratamiento. Siempre busque el consejo de su médico u otro proveedor
          de salud calificado con cualquier pregunta que pueda tener sobre una
          condición médica.
        </p>
        <div className="flex items-center justify-center gap-4 mt-4" data-id="element-167">
          <button onClick={() => setPrivacyOpen(true)} className="text-stone-500 hover:text-amber-400 text-xs underline underline-offset-2 transition-colors" data-id="element-168">
            Política de Privacidad
          </button>
          <span className="text-stone-700" data-id="element-169">•</span>
          <button onClick={() => setTermsOpen(true)} className="text-stone-500 hover:text-amber-400 text-xs underline underline-offset-2 transition-colors" data-id="element-170">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      <PolicyModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-171">
        <p className="text-stone-400 text-xs italic" data-id="element-172">
          Última actualización: Abril 2026
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-173">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-174">
          Al adquirir nuestro producto digital, recopilamos únicamente la
          información necesaria para procesar su compra: dirección de correo
          electrónico y datos de pago. No almacenamos información de tarjetas de
          crédito directamente; estos datos son procesados de forma segura por
          nuestro proveedor de pagos.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-175">
          2. Uso de la Información
        </h3>
        <p data-id="element-176">
          Utilizamos su información exclusivamente para: entregar el producto
          digital adquirido, enviar confirmación de compra y proporcionar
          soporte relacionado con su compra. No vendemos, alquilamos ni
          compartimos su información personal con terceros con fines de
          marketing.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-177">
          3. Protección de Datos
        </h3>
        <p data-id="element-178">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-179">4. Cookies</h3>
        <p data-id="element-180">
          Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
          del proceso de compra. No utilizamos cookies de seguimiento
          publicitario.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-181">5. Sus Derechos</h3>
        <p data-id="element-182">
          Usted tiene derecho a acceder, rectificar o eliminar sus datos
          personales en cualquier momento. Para ejercer estos derechos, puede
          comunicarse con nosotros a través de los canales disponibles en
          nuestro sitio.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-183">
          6. Cambios en esta Política
        </h3>
        <p data-id="element-184">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta misma página
          con la fecha de actualización correspondiente.
        </p>
      </PolicyModal>

      <PolicyModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-185">
        <p className="text-stone-400 text-xs italic" data-id="element-186">
          Última actualización: Abril 2026
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-187">
          1. Producto Digital
        </h3>
        <p data-id="element-188">
          El Protocolo P.A.U. es un producto digital en formato PDF que se
          entrega de forma inmediata tras la confirmación del pago. Al completar
          la compra, recibirá acceso al archivo descargable.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-189">2. Uso Personal</h3>
        <p data-id="element-190">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, modificación o reventa
          total o parcial del material sin autorización expresa por escrito.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-191">
          3. Naturaleza del Producto
        </h3>
        <p data-id="element-192">
          Este producto es una herramienta educativa e informativa. No
          constituye consejo médico, psicológico ni terapéutico. Si padece
          trastornos del sueño severos o condiciones de salud mental, consulte a
          un profesional de la salud cualificado.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-193">
          4. Política de Reembolso
        </h3>
        <p data-id="element-194">
          Debido a la naturaleza digital e inmediata del producto, no se ofrecen
          reembolsos una vez realizada la descarga. Si experimenta problemas
          técnicos con la entrega, nos comprometemos a resolver la incidencia de
          forma oportuna.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-195">
          5. Limitación de Responsabilidad
        </h3>
        <p data-id="element-196">
          Los resultados pueden variar según cada individuo. No garantizamos
          resultados específicos derivados del uso de este protocolo. El usuario
          asume la responsabilidad total del uso que haga del contenido.
        </p>
        <h3 className="text-white font-semibold text-base" data-id="element-197">
          6. Propiedad Intelectual
        </h3>
        <p data-id="element-198">
          Todo el contenido, diseño, textos y metodología del Protocolo P.A.U.
          están protegidos por derechos de autor. Cualquier uso no autorizado
          será perseguido conforme a la legislación aplicable.
        </p>
      </PolicyModal>
    </>;
}